.root {
  display: grid;
  position: relative;
  min-width: 0;
  width: 100%;
}
.content {
  grid-area: 1 / 1;
  min-width: 0;
}
